<template>
  <v-container>
    <!--    Heading-->
    <v-row>
      <v-col cols="2" class="primary--text">
        <h4 class="title mb-2">{{ $route.name }}</h4>
        <p style="font-size: .7rem"></p>
      </v-col>
    </v-row>

    <!--    Page-->
    <v-row>
      <v-col class="">
        <v-row>
          <v-col cols="12" sm="6" xl="4">
            <p>Orders</p>
            <v-sheet
              class="text-center primary--text"
              style="border-radius: 1rem"
              elevation="1"
              light
              color="#e4e4e4"
            >
              <v-row
                class="d-flex flex-row align-center"
                style="min-height: 15rem"
              >
                <v-col>
                  <v-icon
                    color="primary"
                    style="font-size: 40px; background-color: #ffd400; padding: 20px; border-radius: 50%"
                  >
                    mdi-order-alphabetical-ascending
                  </v-icon>
                </v-col>
                <v-col>
                  <p style="margin-bottom: 0px">Total Orders</p>
                  <h2>{{ $store.getters["Dashboard/totalTrips"] }}</h2>
                </v-col>
                <v-divider vertical></v-divider>

                <v-col>
                  <div>
                    <p style="margin-bottom: 0px">Completed Orders</p>
                    <h2 style="margin-bottom: 1rem">
                      {{ $store.getters["Dashboard/completedTrips"] }}
                    </h2>
                  </div>
                  <v-divider></v-divider>
                  <div>
                    <p style="margin-bottom: 0px; margin-top: 1rem">
                      Pending Orders
                    </p>
                    <h2>{{ $store.getters["Dashboard/pendingTrips"] }}</h2>
                  </div>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>

          <v-col cols="12" sm="6" xl="4">
            <p>Drivers</p>
            <v-sheet
              class="text-center primary--text"
              style="border-radius: 1rem"
              elevation="1"
              light
              color="#e4e4e4"
            >
              <v-row
                class="d-flex flex-row align-center"
                style="min-height: 15rem"
              >
                <v-col>
                  <v-icon
                    color="primary"
                    style="font-size: 40px; background-color: #ffd400; padding: 20px; border-radius: 50%"
                  >
                    mdi-account-group
                  </v-icon>
                </v-col>
                <v-col>
                  <p style="margin-bottom: 0px">Total Drivers</p>
                  <h2>{{ $store.getters["Dashboard/totalDrivers"] }}</h2>
                </v-col>
                <v-divider vertical></v-divider>

                <v-col>
                  <div>
                    <p style="margin-bottom: 0px">Active Drivers</p>
                    <h2 style="margin-bottom: 1rem">
                      {{ $store.getters["Dashboard/activeDrivers"] }}
                    </h2>
                  </div>
                  <v-divider></v-divider>
                  <div>
                    <p style="margin-bottom: 0px; margin-top: 1rem">
                      Inactive Drivers
                    </p>
                    <h2>{{ $store.getters["Dashboard/inactiveDrivers"] }}</h2>
                  </div>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>

          <v-col cols="12" sm="6" xl="4">
            <p>Trips</p>
            <v-sheet
              class="text-center primary--text"
              elevation="1"
              style="border-radius: 1rem"
              light
              color="#e4e4e4"
            >
              <v-row
                class="d-flex flex-row align-center"
                style="min-height: 15rem"
              >
                <v-col>
                  <v-icon
                    color="primary"
                    style="font-size: 40px; background-color: #ffd400; padding: 20px; border-radius: 50%"
                  >
                    mdi-order-bool-descending-variant
                  </v-icon>
                </v-col>
                <v-col>
                  <p style="margin-bottom: 0px">Total Trips</p>
                  <h2>{{ $store.getters["Dashboard/totalTrips"] }}</h2>
                </v-col>
                <v-divider vertical></v-divider>

                <v-col>
                  <div>
                    <p style="margin-bottom: 0px">Completed Trips</p>
                    <h2 style="margin-bottom: 1rem">
                      {{ $store.getters["Dashboard/completedTrips"] }}
                    </h2>
                  </div>
                  <v-divider></v-divider>
                  <div>
                    <p style="margin-bottom: 0px; margin-top: 1rem">
                      Cancelled Trips
                    </p>
                    <h2>{{ $store.getters["Dashboard/pendingTrips"] }}</h2>
                  </div>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Dashboard",

  created() {
    this.$store.dispatch("Dashboard/fetchDrivers");
    this.$store.dispatch("Dashboard/fetchTrips");
  }
};
</script>

<style scoped>
.compact-form {
  transform: scale(0.675);
  transform-origin: left;
}
</style>
